import {Component, OnInit} from '@angular/core';
import { CommonSvgIconsComponent } from '../../common-svg-icons/common-svg-icons.component';
import {AuthService} from "../../../../core/services/auth.service";

@Component({
  selector: 'app-profile',
  standalone: true,
  imports: [CommonSvgIconsComponent],
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})

export class ProfileComponent implements OnInit{

  public isProfile : boolean = false;
  userLogged: any = {};

  constructor(private authService: AuthService) {
  }

  logout(){
    this.authService.logout();
  }

  ngOnInit(): void {
    this.userLogged = this.authService.getUser();
  }

}
